import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {LocalStorageService} from '../services/local-storage.service';
import {UserService} from "../services/user.service";

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService implements CanActivate {

  constructor(private router: Router, private localStorageService: LocalStorageService, private userService: UserService) { }

  // async canActivate() {
  //   if (this.localStorageService.get('token')) {
  //     await this.router.navigate(['login']);
  //     return false;
  //   } else {
  //     return true;
  //   }
  // }


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userService.isValid()) {
      return true;
    } else {
      await this.router.navigate(['login'], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }
  }
}
